import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { head } from "@omni/utils/array.utils";
import { cn } from "@omni/utils/styles";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useStoreFullName } from "@/components/Store/utils/useStoreFullName.hook";
import { useThunkDispatch } from "@/redux/dispatcher";
import {
    CTAAction,
    CTAActions
} from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as StoreDetailsModule from "@/redux/modules/api/data/stores/storeDetails/storeDetails.module";
import { getStoreDetails } from "@/redux/modules/api/data/stores/storeDetails/storeDetails.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { TApiAction } from "@/redux/store.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    storeId: string;
};

const ChangeECornerStoreAction = ({ storeId }: Props) => {
    const dispatch = useThunkDispatch();
    const { t } = useGranite();
    const { closeDialog, setLoading, isLoading } = useCallToActionsContext();
    const store = useSelector(getStoreDetails);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const getStore = async () => {
            dispatch(StoreDetailsModule.load(storeId));
        };

        getStore();
    }, []);

    const onSubmit = () => {
        setLoading(true);
        dispatch(CartModule.changeStoreToECorner()).then(
            (action: TApiAction) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            }
        );
    };

    const storeFullName = useStoreFullName(store);

    return (
        <>
            <div className={"storePicker-layout--content"}>
                <p>{t("cta.changeStore.action.changeStoreToEcorner.info")}</p>
            </div>
            <div className={"storePicker-layout--footer"}>
                <div
                    className={cn(
                        "d-flex w-100 m-0 mt-2 mt-sm-3 align-items-center justify-content-end"
                    )}
                >
                    <Button
                        test="changeECornerStore-button-submit"
                        type={"button"}
                        color={"success"}
                        onClick={onSubmit}
                        loading={isLoading}
                    >
                        {t(
                            "cta.changeStoreToEcorner.action",
                            storeFullName || ""
                        )}
                    </Button>
                </div>
            </div>
        </>
    );
};

const changeECornerStore: CTAAction = (
    _: CartItem | null,
    action: CTAActions
) => {
    const storeId = head(action.parameters);

    return <ChangeECornerStoreAction storeId={storeId} />;
};

export default changeECornerStore;
